(() => {
  "use strict";

  const API_BASE = "https://wishlist-api.stylinarts.com/_wishlist";
  const COUNT_SEL = "[data-sa-wishlist-count]";

  function normalizeItems(payload) {
    const raw = Array.isArray(payload)
      ? payload
      : (payload && Array.isArray(payload.items) ? payload.items : []);

    return raw
      .map((it) => {
        if (typeof it === "string") return { handle: it, product_id: null };
        if (it && typeof it === "object") {
          const handle = it.product_handle || it.handle || it.slug || "";
          const product_id = it.product_id || it.productId || it.id || null;
          return { handle, product_id };
        }
        return null;
      })
      .filter(Boolean)
      .filter((x) => typeof x.handle === "string" && x.handle.length);
  }

  async function getWishlistCount() {
    const res = await fetch(API_BASE, { credentials: "include" });
    if (!res.ok) throw new Error(`Wishlist API GET failed (${res.status})`);
    const payload = await res.json();
    return normalizeItems(payload).length;
  }

  async function renderCount() {
    const badge = document.querySelector(COUNT_SEL);
    if (!badge) return;

    try {
      const n = await getWishlistCount();
      if (n > 0) {
        badge.textContent = String(n);
        badge.style.display = "";
      } else {
        badge.textContent = "0";
        badge.style.display = "none";
      }
    } catch (e) {
      // SILENT FAIL: header must not depend on API
      // (log is fine for debugging; you can remove later if you want)
      console.error(e);
    }
  }

  function boot() {
    renderCount();
  }

  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
  document.addEventListener("shopify:section:select", boot);

  // Expose for other scripts (collection hearts) to refresh badge after toggle
  window.saWishlistHeaderRefresh = renderCount;
})();
